import React, { FC } from 'react';

import { EditorContext } from './editorContext';
import { useAutocompleteAriaHostState } from './hooks';
import { HostContext } from './hostContext';

const AutocompleteAriaHost: FC = ({ children }) => {
  const { hostContextValue, editorContextValue } = useAutocompleteAriaHostState();

  return (
    <HostContext.Provider value={hostContextValue}>
      <EditorContext.Provider value={editorContextValue}>{children}</EditorContext.Provider>
    </HostContext.Provider>
  );
};

export default AutocompleteAriaHost;
